import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  'システム開発におけるUX/UIの知見をどう組織に根づかせるか。JTBビジネストラベルソリューションズ様に対し、業務システムを題材にした全3回のワークショップを設計・実施し、UX/UIの基礎からプロジェクト推進力までを獲得いただいた事例をご紹介します。'

const ogpImg = `${SITE_URL}/images/img/cases/jtb-cwt/ogp_jtbcwt.png`

/** HeadMeta と JSON-LD で共有するメタ情報 */
export const jtbCwtPageMeta: PageMeta = {
  title:
    '株式会社JTBビジネストラベルソリューションズ｜全3回のUX/UIワークショップで、プロジェクトを前に進める共通言語を獲得｜事例｜Aitria（アイトリア）',
  description,
  keyword: '事例 実績 業務システム UX/UI ワークショップ',
  image: ogpImg,
  url: `${SITE_URL}/cases/jtb-cwt/`,
}

export const jtbCwtSchema = buildCaseStudySchema({
  slug: 'jtb-cwt',
  pageTitle: jtbCwtPageMeta.title,
  description: jtbCwtPageMeta.description,
  headline: '全3回のUX/UIワークショップで、プロジェクトを前に進める共通言語を獲得',
  alternativeHeadline: '株式会社JTBビジネストラベルソリューションズ',
  primaryImage: ogpImg,
  images: [ogpImg, `${SITE_URL}/images/img/cases/jtb-cwt/mv.webp`],
  clientName: '株式会社JTBビジネストラベルソリューションズ',
  breadcrumbLabel: '全3回のUX/UIワークショップで、プロジェクトを前に進める共通言語を獲得',
})
